import { FaFireExtinguisher, FaUsers, FaGraduationCap, FaHandHoldingHeart } from 'react-icons/fa';

const counter = [
    {
        id: 1,
        icon: <FaFireExtinguisher />, // Fire extinguisher icon
        title: 'Incidents Responded',
        count: '1000',
    },
    {
        id: 2,
        icon: <FaUsers />, // Users icon
        title: 'Dedicated Firefighters',
        count: '50',
    },
    {
        id: 3,
        icon: <FaGraduationCap />, // Graduation cap icon
        title: 'Safety Trainings',
        count: '300',
    },
    {
        id: 4,
        icon: <FaHandHoldingHeart />, // Hand holding heart icon
        title: 'Community Outreach',
        count: '10',
    },
];

export default counter;